import { ComputedPlaylistTeaserImageRatio } from './types'

const IMAGE_RATIOS: ComputedPlaylistTeaserImageRatio = {
  mobile: '1_1',
  tablet: '1_1',
  desktop: '1_1',
}

const IMAGE_WIDTHS = {
  desktop: 123,
  tablet: 123,
  mobile: 150,
  mobileSmall: 150,
}

export { IMAGE_RATIOS, IMAGE_WIDTHS }
